import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";

// import { GithubIcon } from '../../icons'
// import useQuery from '../../utils/useQuery'
import { useHistory, useLocation, useParams } from "react-router-dom";
import { auth, provider } from "../../firebase";
import { signInWithPopup } from "firebase/auth";
import { userServices } from "../../services";

import GetEmailPopup from "../Popup/GetEmailPopup";
import { GoogleIcon } from "../../icons";
import { SnackbarContext } from "../../context/SnackbarContext";
import { config } from "../../assets/config/config";
import { CircularProgress } from "@mui/material";

function GoogleAuthForm({
  closemodel,
  name,
  setAccountStatus,
  isRecruiter,
  isLogin = false,
  referral = "",
  setReferral
}) {
  const { setIsProfileFreezed } = useContext(AuthContext);
  const {
    setUser,
    setAccessToken,
    startSilentRefresh,
    GetSignUpDependency,
    setLoaded,
    isJobapply,
    checkNewNotification,
  } = useContext(AuthContext);
  const [showPopup, setShowPopup] = useState(false);
  const [getEmailId, setGetEmailId] = useState("");
  const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { openSnackbar, closeSnackbar } = useContext(SnackbarContext);
  const history = useHistory();
  const location = useLocation();
  const JobId = location?.pathname?.includes("open-audition")
    ? location?.pathname?.split("/")?.pop()
    : null;
  const isFindJob = location?.pathname?.includes("find-jobs")
    ? location?.pathname?.split("/")?.pop()
    : null;
  let first_name, last_name, userId;
  useEffect(() => {
    const handleEvent = (e) => {
      if (isLoading) {
        e.stopPropagation();
        e.preventDefault();
      }
    };
    document.addEventListener("click", handleEvent, true);
    return () => {
      document.removeEventListener("click", handleEvent, true);
    };
  });

  const onSubmit = () => {
    setIsLoading(true);
    signInWithPopup(auth, provider)
      .then((result) => {
        var name = result?.user?.displayName?.split(" ");
        first_name = name[0];
        last_name = result?.user?.displayName?.substring(name[0]?.length);
        userId = result.user.uid;

        setUserData({
          email: result?.user?.providerData[0]?.email,
          oauth_id: result.user.uid,
          first_name: first_name,
          last_name: last_name,
          registered_on: new Date(),
          oauth_type: "Google",
          user_referral_code: referral ? referral.toLowerCase() : "",
        });
        let user_Data = {
          email: result?.user?.providerData[0]?.email,
          oauth_id: result.user.uid,
          first_name: first_name,
          last_name: last_name,
          isRecruiter: isRecruiter ? true : false,
          registered_on: new Date(),
          oauth_type: "Google",
          isLogin: isLogin ? isLogin : false,
          user_referral_code: referral ? referral.toLowerCase() : "",
        };
        userServices.handleOauthUser(user_Data).then(
          (result) => {
            localStorage.setItem('hasValidUserSession', 'true');
            setLoaded(false);
            setUser(result.data.user);
            setReferral("")
            if (result.data.user?.isFreezed) {
              setIsProfileFreezed(result.data.user.isFreezed);
            } else {
              setIsProfileFreezed(false);
            }
            setAccessToken(result.data.token);
            startSilentRefresh();
            GetSignUpDependency();

            if (isJobapply === true || isFindJob) {
              closemodel();
            } else {
              if (result.data.user.user_type == 1) {

                if (result.data.user?.talenter?.is_profile_creation_completed) {
                  history.push(`/talent/${result.data.user?.userUniqueId}`);
                } else {
                  history.push(`/app/dashboard`);
                }

                const payload = {
                  user_id: `${result.data.user?.user_id}`,
                  message: `<p><a class="talent_name" href="${config.admin_url}/app/talent-management/profile/${result.data.user?.user_id}">${result.data.user?.first_name} (Talent ${result.data.user?.user_id})</a> signed in using Google</p>`,
                };
                userServices.createLog(payload);
              } else {
                if (result.data.user.user_type == 2) {
                  localStorage.setItem('hasValidUserSession', 'true');

                  if (
                    result.data.user?.recruiter?.is_profile_creation_completed
                  ) {
                    if (
                      location?.pathname?.includes("find-talents") ||
                      location?.pathname?.includes("talents")
                    ) {
                    } else {
                      history.push(`/app/my-projects`);
                    }
                  } else {
                    history.push(
                      `/app/recruiter-form/${result.data.user.userUniqueId}`
                    );
                  }

                  const payload = {
                    user_id: `${result.data.user?.user_id}`,
                    message: `<p><a class="talent_name" href="${config.admin_url}/app/recruiter/details/${result.data.user?.user_id}">${result.data.user?.first_name} (Recruiter ${result.data.user?.user_id})</a> signed in using Google</p>`,
                  };
                  userServices.createLog(payload);
                }
              }
              closemodel();
            }

            setLoaded(true);
            setIsLoading(false);

            checkNewNotification(result.data.user?.user_id);
          },
          (error) => {
            if (error?.response?.data?.code === 400) {
              localStorage.removeItem('hasValidUserSession');

              setAccountStatus(error?.response?.data?.message);
              setLoaded(true);
              openSnackbar(error?.response?.data?.message, "error");
            }
            setIsLoading(false);
          }
        );
      })
      .catch((err) => {
        setIsLoading(false);
        localStorage.removeItem('hasValidUserSession');

      })
      .finally(() => {
        localStorage.removeItem('hasValidUserSession');

        document.removeEventListener(
          "click",
          (e) => {
            if (isLoading) {
              e.stopPropagation();
              e.preventDefault();
            }
          },
          false
        );
      });
  };

  const HandleEmail = (newEmail) => {
    setUserData({ ...userData, email: newEmail });
    let user_data = { ...userData, email: newEmail };
    userServices
      .handleOauthUser(user_data)
      .then((result) => {
        setUser(result.data.user);
        setAccessToken(result.data.token);
        startSilentRefresh();
        GetSignUpDependency();
        if (result.data.user_type == 1) {
          history.push(`/app/dashboard`);
        } else {
          history.push(`/find-talents`);
        }
      })
      .catch((err) => { });
  };

  return (
    <>
      <GetEmailPopup
        openDialog={showPopup}
        setGetEmailId={setGetEmailId}
        onSubmit={HandleEmail}
      />
      {isLoading ? (
        <div className="authContainer">
          <CircularProgress size={"24px"} sx={{ color: "#9B26B6" }} />
        </div>
      ) : (
        <button
          className="auth_btn white-bg font-medium"
          onClick={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <GoogleIcon className="w-6 h-6" aria-hidden="true" />
          <p>{name}</p>
        </button>
      )}
    </>
  );
}

export default GoogleAuthForm;
